import { Inject, Injectable } from '@angular/core';
import { LOCAL_STORAGE, StorageService } from 'ngx-webstorage-service';
import { BreadcrumbLink } from '../models/Breadcrumb';
import { Utilities } from '../utilities';
import { Control } from '../models/Flow';
import { publishFacade } from '@angular/compiler';


@Injectable({
  providedIn: 'root'
})
export class TCCPLocalStorageService {

  constructor(@Inject(LOCAL_STORAGE) private storage: StorageService) { }
  public vehicleModel: BreadcrumbLink;
  public btVehicleModel: BreadcrumbLink;
  public vehicleYear: BreadcrumbLink;
  public btVehicleYear: BreadcrumbLink;
  public vehicleVin: BreadcrumbLink;
  public home: BreadcrumbLink;
  public feature: BreadcrumbLink;
  public selectedFeatureId: string = null;
  public featureType: string = null;
  public appName = '';
  public phoneModel = '';
  public headUnitConfig = '';
  public headUnitConfigList: number[] = [];
  public bluetoothIssueId = '';
  public vehicleModelName = '';
  public btVehicleModelName = '';
  public btVehicleVin = '';
  public isPreview = false;
  public fromDashboard = false;
  public supportTopics: BreadcrumbLink;
  public subTopic: BreadcrumbLink;
  public vehilceFeatures: Control[] = [];
  public enableReview = false;
  public isPreviewFromPublish = false;
  public btSearchedByVin = false;
  private vehicleModelCode: string;
  private btVehicleModelCode: string;
  private vehicleMPCCode: string;
  private btVehicleMPCCode: string;
  private vehicleModelYear: number;
  private mappedFeatures: string[] = [];
  private models: string;
  private showDisclaimer = false;
  private showBluetoothComp = true;
  private isBluetoothFeatureAvailable = true;
  private selectedStep = null;
  private telematicsMPCCode: string;
  private vinAutoSuggesstion: string[] = [];
  private cachedVehicles: any;
  private cachedFeatures: any;
  private selectedDivision: string;
  public vehicleGeneration: BreadcrumbLink;
  public backToPhoneSelection = false;
  /* Progress bar related variables */
  private progressBarTracker;
  private selectedStepIssueId = null;
  private selectedStepControlName = null;
  private isNestedStep = null;
  private afterControlStep = false;
  private enableProgressBar = false;
  private phoneCompatability = false;
  private btPhoneModel: any;
  private btPhoneManufacturer: any;
  public huPhoneConfigInfoList: any;
  

  public setAfterControlStep(value: any) {
    this.afterControlStep = value;
    this.storage.set('afterControlStep', value);
  }
  public getAfterControlStep(): any {
    return this.storage.get('afterControlStep') || this.afterControlStep;
  }

  public setNestedStep(value: any) {
    this.isNestedStep = value;
    this.storage.set('isNestedStep', value);
  }

  public getNestedStep(): any {
    return this.storage.get('isNestedStep') || this.isNestedStep;
  }

  public setProgressBar(value: any) {
    this.enableProgressBar = value;
    this.storage.set('enableProgressBar', value);
  }

  public getProgressBar(): any {
    return this.storage.get('enableProgressBar') || this.enableProgressBar;
  }

  /* storage for new phone compatability screen */
  public setPhoneCompatabilityDirectLink(value: any) {
    this.phoneCompatability = value;
    this.storage.set('PhoneCompatability', value);
  }

  public getPhoneCompatabilityDirectLink(): any {
    return this.storage.get('PhoneCompatability') || this.phoneCompatability;
  }

  public setBackToPhoneSelection(value: boolean) {
   this.backToPhoneSelection = value;
  }

  public getBackToPhoneSelection(): any {
    return this.backToPhoneSelection;
  }

  public setBtSearchedByVin(value: boolean) {
    this.btSearchedByVin = value;
  }

  public getBtSearchedByVin(): boolean {
    return this.btSearchedByVin;
  }

  public setPhoneManufacturerValues(manufacturer: any, model: any) {
    this.btPhoneManufacturer = manufacturer;
    this.btPhoneModel = model;
    this.storage.set('btPhoneManufacturer',manufacturer);
    this.storage.set('btPhoneModel', model);
  }

  public getBtPhoneManufacturer(): any {
    return this.storage.get('btPhoneManufacturer') || this.btPhoneManufacturer;
  }

  public getBtPhoneModel(): any {
    return this.storage.get('btPhoneModel') || this.btPhoneModel;
  }

  public setHuPhoneConfigInfoList(value: any) {
    this.huPhoneConfigInfoList = value;
    this.storage.set('huPhoneConfigInfoList', value);
  }

  public getHuPhoneConfigInfoList(): any {
    return this.storage.get('HuPhoneConfigInfoList') || this.huPhoneConfigInfoList;
  }

  public getSelectedStepIssueId(): any {
    return this.storage.get('selectedStepIssueId') || this.selectedStepIssueId;
  }
  public setSelectedStepIssueId(value: any) {
    this.storage.set('selectedStepIssueId', value);
    this.selectedStepIssueId = value;
  }

  public getSelectedStepControlName(): any {
    return this.storage.get('selectedStepControlName') || this.selectedStepControlName;
  }

  public setSelectedStepControlName(value: any) {
    this.storage.set('selectedStepControlName', value);
    this.selectedStepControlName = value;
  }

  public getSelectedStep(): any {
    return this.storage.get('SelectedStep') || this.selectedStep;
  }
  public setSelectedStep(value: any) {
    this.storage.set('SelectedStep', value);
    this.selectedStep = value;
  }

  public getProgressBarTracker(): any {
    return this.storage.get('ProgressBarTracker') || this.progressBarTracker;
  }

  public setProgressBarTracker(value: any) {
    this.storage.set('ProgressBarTracker', value);
    this.progressBarTracker = value;
  }

  public getSelectedApp(): any {
    return this.storage.get('SelectedDivision') || this.selectedDivision;
  }
  public setSelectedDivision(value: any) {
    this.storage.set('SelectedDivision', value);
    this.selectedDivision = value;
  }
  public getVinAutoSuggesstion(): any {
    return this.storage.get('VINAutoSuggesstion') || this.vinAutoSuggesstion;
  }
  public setVinAutoSuggesstion(value: any) {
    this.storage.set('VINAutoSuggesstion', value);
    this.vinAutoSuggesstion = value;
  }
  public getCachedFeatures(): any {
    return this.storage.get('CACHEDFEATURES') || this.cachedFeatures;
  }
  public setCachedFeatures(value: any) {
    this.cachedFeatures = value;
    this.storage.set('CACHEDFEATURES', value);
    this.feature = value;
  }
  public getCachedVehicles(): any {
    return this.storage.get('VEHICLES') || this.cachedVehicles;
  }

  public setCachedVehicles(value: any) {
    this.storage.set('VEHICLES', value);
    this.cachedVehicles = value;
  }

  public getTelematicsMPCCode(): string {
    return this.storage.get('HUTMPC') || this.telematicsMPCCode;
  }
  public setTelematicsMPCCode(value: string) {
    this.storage.set('HUTMPC', value);
    this.telematicsMPCCode = value;
  }
  public getShowDisclaimer(): boolean {
    return this.showDisclaimer;
  }
  public setShowDisclaimer(value: boolean) {
    this.showDisclaimer = value;
  }

  public getBTFeatAvailable(): boolean {
    return this.isBluetoothFeatureAvailable;
  }
  public setBTFeatAvailable(value: boolean) {
    this.isBluetoothFeatureAvailable = value;
  }


  public getShowBluetoothComp(): boolean {
    return this.showBluetoothComp;
  }
  public setShowBluetoothComp(value: boolean) {
    this.showBluetoothComp = value;
  }

  getModels(): any {
    return this.storage.get('MODELS') || this.models;
  }

  setModels(value: any) {
    this.storage.set('MODELS', value);
    this.models = value;
  }

  setBtModels(value: any){
    this.storage.set('BTMODELS', value);
    this.models = value;    
  }

  getBtModels(): any {
    return this.storage.get('BTMODELS') || this.models;
  }

  getMappedFeatures(): string[] {
    return this.storage.get('FEATURES') || this.mappedFeatures;
  }

  setMappedFeatures(value: string[]) {
    this.storage.set('FEATURES', value);
    this.mappedFeatures = value;
  }

  getVehicleModelYear(): number {
    return this.storage.get('MODELYEAR') || this.vehicleModelYear;
  }

  setVehicleModelYear(value: number) {
    this.storage.set('MODELYEAR', value);
    this.vehicleModelYear = value;
  }
  

  getVin(): string {
    return this.storage.get('VIN');
  }

  setVin(value: string) {
    this.storage.set('VIN', value);
  }
  setModelCode(value: string) {
    this.storage.set('VEHICLEMODELCODE', value);
    this.vehicleModelCode = value;
  }

  setBtModelCode(value: string) {
    this.storage.set('BTVEHICLEMODELCODE', value);
    this.btVehicleModelCode = value;
  }

  getModelCode(): string {
    return this.vehicleModelCode || this.storage.get('VEHICLEMODELCODE');
  }


  getBtModelCode(): string {
    return this.btVehicleModelCode || this.storage.get('BTVEHICLEMODELCODE');
  }

  setMPCCode(value: string) {
    this.storage.set('VEHICLEMPC', value);
    this.vehicleMPCCode = value;
  }

  setBtMPCCode(value: string) {
    this.storage.set('BTVEHICLEMPC', value);
    this.btVehicleMPCCode = value;
  }

  getMPCCode(): string {
    return this.vehicleMPCCode || this.storage.get('VEHICLEMPC');
  }

  getBtMPCCode() {
    return this.vehicleMPCCode || this.storage.get('BTVEHICLEMPC');
  }

  getHome(): BreadcrumbLink {
    return this.home || this.storage.get('HOME');
  }
  setHome(linkProp: string) {
    this.storage.set('HOME', ({ type: 'HOME', name: 'HOME', link: linkProp }) as BreadcrumbLink);
    this.home = ({ type: 'HOME', name: 'HOME', link: linkProp }) as BreadcrumbLink;
  }

  setRoles(roles: any) {
    this.storage.set('ROLES', roles);
  }

  setUpn(upn: string) {
    this.storage.set('UPN', upn);
  }

  setToken(token: string){
    this.storage.set('TOKENINFO', token);
  }

  setTokenExpiry(expiresOn: string){
    this.storage.set('TOKENEXPIRY', expiresOn);
  }
  
  getUpn(): string {
    return this.storage.get('UPN');
  }

  getToken(){
    return this.storage.get('TOKENINFO')
  }

  getTokenExpiry(){
    return this.storage.get('TOKENEXPIRY')
  }

  getDivision(): string {
    return this.storage.get('DIVISION');
  }
  setDivision(division: string) {
    this.storage.set('DIVISION', division);
  }

  getRoles(): Array<string> {
    return this.storage.get('ROLES');
  }

  getAppName(): string {
    return this.appName;
  }

  setAppName(value: string) {
    this.storage.set('appName', value);
    this.appName = value;
  }

  getSelectedFeatureId(): string {
    return this.selectedFeatureId || this.storage.get('FEATUREID');
  }

  setSelectedFeatureId(value: string) {
    this.storage.set('FEATUREID', value);
    this.selectedFeatureId = value;
  }

  getFeatureType(): string {
    return this.featureType || this.storage.get('FEATURETYPE');
  }

  setFeatureType(value: string) {
    this.storage.set('FEATURETYPE', value);
    this.featureType = value;
  }

  getVehicleVin(): BreadcrumbLink {
    return this.vehicleVin || this.storage.get('VIN');
  }

  setVehicleVin(value: string, linkProp: string) {
    this.storage.set('VIN', ({ type: 'VIN', name: value ? value : '', link: linkProp }) as BreadcrumbLink);
    this.vehicleVin = ({ type: 'VIN', name: value ? value : '', link: linkProp }) as BreadcrumbLink;
  }

  getVehicleModel(): BreadcrumbLink {
    return this.vehicleModel || this.storage.get('MODEL');
  }

  setVehicleModel(value: string, linkProp: string) {
    this.storage.set('MODEL', ({ type: 'MODEL', name: value ? decodeURIComponent(value) : '', link: linkProp }) as BreadcrumbLink);
    this.vehicleModel = ({ type: 'MODEL', name: value ? decodeURIComponent(value) : '', link: linkProp }) as BreadcrumbLink;
  }

  getBtVehicleModel(): BreadcrumbLink {
    return this.btVehicleModel || this.storage.get('BTMODEL');
  }

  setBtVehicleModel(value: string, linkProp: string) {
    this.storage.set('BTMODEL', ({ type: 'BTMODEL', name: value ? decodeURIComponent(value) : '', link: linkProp }) as BreadcrumbLink);
    this.btVehicleModel = ({ type: 'BTMODEL', name: value ? decodeURIComponent(value) : '', link: linkProp }) as BreadcrumbLink;
  }

  getVehicleYear(): BreadcrumbLink {
    return this.vehicleYear || this.storage.get('YEAR');
  }

  setVehicleYear(value: number, linkProp: string) {
    this.storage.set('YEAR', ({ type: 'YEAR', name: value ? value : '', link: linkProp }) as BreadcrumbLink);
    this.vehicleYear = ({ type: 'YEAR', name: value ? value : '', link: linkProp }) as BreadcrumbLink;
  }

  getBtVehicleYear(): BreadcrumbLink {
    return this.btVehicleYear || this.storage.get('BTYEAR');
  }

  setBtVehicleYear(value: number, linkProp: string) {
    this.storage.set('BTYEAR', ({ type: 'BTYEAR', name: value ? value : '', link: linkProp }) as BreadcrumbLink);
    this.btVehicleYear = ({ type: 'BTYEAR', name: value ? value : '', link: linkProp }) as BreadcrumbLink;
  }

  setVehicleGeneration(value: string, linkProp: string) {
    this.storage.set('GENERATION', ({ type: 'GENERATION', name: value ? value : '', link: linkProp }) as BreadcrumbLink);
    this.vehicleGeneration = ({ type: 'GENERATION', name: value ? value : '', link: linkProp }) as BreadcrumbLink;
  }

  getVehicleGeneration(): BreadcrumbLink {
    return this.vehicleGeneration || this.storage.get('GENERATION');
  }

  getFeature(): BreadcrumbLink {
    return this.feature || this.storage.get('FEATURE');
  }

  getSupportTopics(): BreadcrumbLink {
    return this.supportTopics || this.storage.get('SUPPORTTOPICS');
  }

  setSupportTopics(value: string, linkProp: string) {
    this.storage.set('SUPPORTTOPICS', ({ type: 'SUPPORTTOPICS', name: value ? value : '', link: linkProp }) as BreadcrumbLink);
    this.supportTopics = ({ type: 'SUPPORTTOPICS', name: value ? value : '', link: linkProp }) as BreadcrumbLink;
  }

  getSubTopic(): BreadcrumbLink {
    return this.subTopic || this.storage.get('SUBTOPIC');
  }

  setSubTopic(value: string, linkProp: string) {
    this.storage.set('SUBTOPIC', ({ type: 'SUBTOPIC', name: value ? value : '', link: linkProp }) as BreadcrumbLink);
    this.subTopic = ({ type: 'SUBTOPIC', name: value ? value : '', link: linkProp }) as BreadcrumbLink;
  }


  setFeature(value: string, linkProp: string) {
    this.storage.set('FEATURE', ({ type: 'FEATURE', name: value ? value : '', link: linkProp }) as BreadcrumbLink);
    this.feature = ({ type: 'FEATURE', name: value ? value : '', link: linkProp }) as BreadcrumbLink;
  }

  getSwitchApp(): boolean {
    return this.storage.get('SWITCHAPP');
  }

  setSwitchApp(value: boolean) {
    this.storage.set('SWITCHAPP', value);
  }

  getPhoneModel(): string {
    return this.phoneModel || this.storage.get('PHONEMODEL');
  }

  setPhoneModel(value: string) {
    this.storage.set('PHONEMODEL', value);
    this.phoneModel = value;
  }

  setPermission(key: string, value: string) {
    this.storage.set(key, value);
  }

  getPermission(key: string): string {
    return this.storage.get(key);
  }

  getHeadUnitConfig(): string {
    return this.headUnitConfig || this.storage.get('HEADUNITCONFIGID');
  }

  setHeadUnitConfig(value: string) {
    this.storage.set('HEADUNITCONFIGID', value);
    this.headUnitConfig = value;
  }


  getHeadUnitConfigList(): number[] {
    return this.headUnitConfigList || this.storage.get('HEADUNITCONFIGIDLIST');
  }

  setHeadUnitConfigList(value: number[]) {
    this.storage.set('HEADUNITCONFIGIDLIST', value);
    this.headUnitConfigList = value;
  }

  clearStorage() {
    this.storage.set('MODEL', ({ name: null, link: null }) as BreadcrumbLink);
    this.storage.set('YEAR', ({ name: null, link: null }) as BreadcrumbLink);
    this.storage.set('FEATURE', ({ name: null, link: null }) as BreadcrumbLink);
    this.storage.set('SUBTOPIC', ({ name: null, link: null }) as BreadcrumbLink);
    this.storage.set('PHONEMODEL', '');
    this.storage.set('HEADUNITCONFIGID', '');
    this.storage.remove('CTContentCreatorUser');
    this.storage.remove('CTContentPublisherUser');
    this.storage.remove('CT-Adminsuperuser');
    this.storage.remove('UPN');
    this.storage.remove('ROLES');
    this.storage.remove('ISPREVIEWFROMPUBLISH');
    this.storage.remove('ISPREVIEW');
    this.storage.remove('ENABLEREVIEW');
    this.storage.remove('VIN');
    this.storage.remove('BANNERCLOSED');
    this.storage.set('GENERATION', ({ name: null, link: null }) as BreadcrumbLink);
    this.clearFlow();
  }
  clearFlow() {
    this.storage.set('flowtracker', '[]');
  }

  setFlow(flowarray: Array<string>) {
    const steps = Utilities.getUniqueList(flowarray);
    this.storage.set('flowtracker', JSON.stringify(steps));
  }

  getFlow() {
    return Utilities.getUniqueList(JSON.parse(this.storage.get('flowtracker'))) || [];
  }

  setBluetoothIssueId(value: string) {
    this.storage.set('BLUETOOTHISSUEID', value);
    this.bluetoothIssueId = value;
  }

  GetBluetoothIssueId(): string {
    return this.bluetoothIssueId || this.storage.get('BLUETOOTHISSUEID');
  }

  getVehicleModelName(): string {
    return this.vehicleModelName || this.storage.get('VEHICLEMODELNAME');
  }

  setVehicleModelName(value: string) {
    this.storage.set('VEHICLEMODELNAME', decodeURIComponent(value));
    this.vehicleModelName = decodeURIComponent(value);
  }


  getBtVehicleModelName(): string {
    return this.btVehicleModelName || this.storage.get('BTVEHICLEMODELNAME');
  }

  setBtVehicleModelName(value: string) {
    this.storage.set('BTVEHICLEMODELNAME', decodeURIComponent(value));
    this.btVehicleModelName = decodeURIComponent(value);
  }

  getBtVehicleVin(): string {
    return this.btVehicleVin || this.storage.get('btVehicleVin');
  }

  setBtVehicleVin(value: string) {
    this.storage.set('btVehicleVin', value);
    this.btVehicleVin = value;
  }

  setPreview(value: boolean) {
    this.storage.set('ISPREVIEW', value);
    this.isPreview = value;
  }

  GetPreview(): boolean {
    return this.isPreview || this.storage.get('ISPREVIEW');
  }

  setFromDashboard(value: boolean){
    this.storage.set('FROMDASHBOARD', value);
    this.fromDashboard = false;
  }

  getFromDashboard():boolean{
    return this.fromDashboard || this.storage.get('FROMDASHBOARD');
  }

  setPreviewFromPublish(value: boolean) {
    this.storage.set('ISPREVIEWFROMPUBLISH', value);
    this.isPreviewFromPublish = value;
  }

  getPreviewFromPublish(): boolean {
    return this.isPreviewFromPublish || this.storage.get('ISPREVIEWFROMPUBLISH');
  }

  setReview(value: boolean) {
    this.storage.set('ENABLEREVIEW', value);
    this.enableReview = value;
  }

  getReview(): boolean {
    return this.enableReview || this.storage.get('ENABLEREVIEW');
  }

  setVehicleFeatures(value: Array<Control>) {
    this.storage.set('VEHICLEFEATURES', value);
    this.vehilceFeatures = value;
  }
  getVehicleFeatures(): Array<Control> {
    return this.vehilceFeatures || this.storage.get('VEHICLEFEATURES');
  }

  /* Remove breadcrumb related storage */
  clearBreadcrumbStorage() {
    this.storage.set('MODEL', null);
    this.storage.set('YEAR', null);
    this.storage.set('FEATURE', null);
    this.storage.set('SUPPORTTOPICS', null);
    this.storage.set('SUBTOPIC', null);
    this.storage.set('MODELYEAR', null);
    this.storage.set('VEHICLEMODELNAME', null);
  }

  getBannerCloseStatus(): boolean {
    return (this.storage.get('BANNERCLOSED') === 'true');
  }

  setbannerCloseStatus(value) {
    this.storage.set('BANNERCLOSED', value + '');
  }

}
